export default __webpack_public_path__ + "static/media/check-checked.336b0798.svg";